import { useTranslation } from 'next-i18next';
import { LabelStatus } from '@zep/types';
import { cn } from '@zep/utils';
export const AdditionalLabel = ({
  status
}: {
  status: LabelStatus;
}) => {
  const {
    t
  } = useTranslation(['subscription']);
  const text = status === LabelStatus.EXPIRED ? t('subscription:SpaceList.tag.expired') : status === LabelStatus.READY ? t('subscription:SpaceList.tag.ready') : status === LabelStatus.FAIL ? t('subscription:SpaceList.tag.fail') : status === LabelStatus.CANCELED ? t('subscription:SpaceDetail.menuInvoice.tagRefunded') : status === LabelStatus.WAITING_FOR_PAYMENT ? t('subscription:SpaceList.tag.pending', '결제 대기') : null;
  return <label className={cn('py-[1px] px-[6px] border border-[#0000000D] rounded-[4px] font-semibold text-caption-1', {
    'text-red bg-redBg': status === LabelStatus.EXPIRED || status === LabelStatus.FAIL || status === LabelStatus.CANCELED,
    'text-primary bg-primaryBg': status === LabelStatus.READY,
    'text-mintDark-hover bg-mintBg': status === LabelStatus.WAITING_FOR_PAYMENT
  })} data-sentry-component="AdditionalLabel" data-sentry-source-file="AdditionalLabel.tsx">
      {text}
    </label>;
};